import clsx from 'clsx';

import { MindMap, Spinner } from '../../../components';

type MindMapCourseProps = {
  onFullScreen?: () => void;
  fullScreenMode?: boolean;
  mindMap: any;
  loading: boolean;
};

export const MindMapCourse: React.FC<MindMapCourseProps> = ({
  onFullScreen,
  fullScreenMode,
  mindMap,
  loading,
}) => {
  const height = fullScreenMode ? 'h-[60rem]' : 'h-[32rem] max-h-[60rem]';

  return (
    <div className={clsx('w-full py-lg flex flex-col justify-center', height)}>
      {loading ? (
        <Spinner alignment="center" size={28} />
      ) : (
        !!mindMap && (
          <MindMap
            className={clsx('rounded-2xl')}
            data={mindMap}
            fullScreenMode={fullScreenMode}
            onFullScreen={onFullScreen}
          />
        )
      )}
    </div>
  );
};
